module.exports = __webpack_public_path__ + "static/media/ETS_Packshot.8eebd964.png";